// There is no real reason why there would not be a root node, so we assumed it to be to be non-null.
const root: HTMLHtmlElement = document.querySelector(':root')! as HTMLHtmlElement

export const getPropertyValue = (property: string): string =>
    window.getComputedStyle(root).getPropertyValue(property)

export const getPropertyValuePx = (property: string): number =>
    +getPropertyValue(property)?.replace('rem', '') * 16

export const setPropertyValue = (property: string, value: string) =>
    root.style.setProperty(property, value)

export const logPropertyValues = (properties: string[]) =>
    properties.forEach((property) => {
        const value = getPropertyValue(property)
        console.log(`${property}:`, value)
    })
